import React from "react";
import styled from "styled-components";
import tw from "twin.macro";
import { SectionHeading as HeadingTitle } from "../misc/Headings.js";

const Container = tw.div`relative`;

const SingleColumn = tw.div`max-w-screen-xl mx-auto py-20 lg:py-24`;

const HeadingInfoContainer = tw.div`flex flex-col items-center`;
const HeadingDescription = tw.p`mt-4 font-medium text-gray-600 text-center max-w-screen-lg`;

const Content = tw.div`mt-16`;

const Card = styled.div(props => [
  tw`md:flex justify-center items-center`,
]);
const Details = tw.div`my-2 md:max-w-md mx-4 sm:mx-8 md:mx-4 lg:mx-8 lg:w-3/6 w-full`;
const Link = tw.a`inline-block text-sm hover:text-secondary-700 font-bold cursor-pointer transition duration-300 w-full py-4 border border-solid border-secondary-500 rounded-3xl text-center align-middle hover:border-primary-500 hover:bg-secondary-100 bg-secondary-700 text-white`;

export default () => {
  const cards = [
    {
      title: "Mrs. Coburn - Resource",
      url: "https://www.amazon.com/hz/wishlist/ls/FG4CGV9RNJC5?ref_=wl_share"
    },
    {
      title: "Mrs. Fussell - Resource",
      url: "https://www.amazon.com/hz/wishlist/ls/BX30T1KHQLYM?ref_=wl_share"
    },
    {
      title: "Mrs. Dyer-Delvisco - Resource",
      url: "https://www.amazon.com/hz/wishlist/ls/7HHAJR4LIB05?ref=cm_sw_em_r_un_un_4utyatphbU5Xk"
    },
    {
      title: "Mrs. \"Habby\" - IT Facilitator/School Counselor",
      url: "https://www.amazon.com/hz/wishlist/ls/15GMBFM9NVCV2?ref_=wl_share"
    },
    {
      title: "Mrs. Johnson - AR",
      url: "https://www.amazon.com/hz/wishlist/ls/JB0LC4W46MML?ref_=wl_share"
    },
    {
      title: "Mrs. Quebedeaux - Art",
      url: "https://www.amazon.com/registries/gl/guest-view/1XCI5SPIAGYV4?fbclid=IwZXh0bgNhZW0CMTEAAR3EWEeJ5ewqlxlZUYQD1ZleKm-fNQva0eB7LaIqBcY4G_QKlvCAOGcOlJU_aem_NReCXPfBhfqcvDykoJ17jA"
    },
    {
      title: "Mrs. Hatfield - Music",
      url: "https://www.amazon.com/hz/wishlist/ls/2ON0XP91H5YC6?ref_=wl_share"
    },
    {
      title: "Mrs. Koger - Elementary PE",
      url: "https://www.amazon.com/hz/wishlist/ls/2885YV8AQBSYE/ref=nav_wishlist_lists_5"
    },
    {
      title: "K3 - Mrs. Favalora",
      url: "https://www.amazon.com/hz/wishlist/ls/1EF9QAMOH5B2?ref=cm_sw_sm_r_un_un_oHmR92fA03Tzv"
    },
    {
      title: "K4A - Mrs. Morales",
      url: "https://www.amazon.com/hz/wishlist/ls/3HAXNK3K1VOC0?ref=cm_sw_sm_r_un_un_94RmpDLjtFgNI"
    },
    {
      title: "K4B - Mrs. Hamel",
      url: "https://www.amazon.com/hz/wishlist/ls/23GUF5RYHSDGT?ref_=wl_share"
    },
    {
      title: "K5A - Mrs. Peltier",
      url: "https://www.amazon.com/hz/wishlist/ls/3RUKCTKMGXZ7G?ref=cm_sw_sm_r_un_un_dSBAIUjN7TgWg"
    },
    {
      title: "K5B - Mrs. Kenney",
      url: "https://www.amazon.com/hz/wishlist/ls/1O30NX75D2E8A?ref_=wl_share"
    },
    {
      title: "1A - Mrs. Carruth",
      url: "https://www.amazon.com/hz/wishlist/ls/18BI5W33GNRRA?ref=cm_sw_sm_r_un_un_vSx7kJy1VCits"
    },
    {
      title: "1B - Mrs. Tynes",
      url: "https://www.amazon.com/hz/wishlist/ls/2PVS1CC5YRBHU?ref=cm_sw_sm_r_un_un_rcAatvQOtmLLk"
    },
    {
      title: "2A - Mrs. Montgomery",
      url: "https://www.amazon.com/hz/wishlist/ls/3EQNJGGNR3F4K?ref_=wl_share"
    },
    {
      title: "2B - Mrs. Givens",
      url: "https://www.amazon.com/hz/wishlist/ls/3RONWAH43VS1K?ref_=wl_share"
    },
    {
      title: "3A - Mrs. Kennedy",
      url: "https://www.amazon.com/hz/wishlist/ls/3CMYTY989G29B?ref=cm_sw_em_r_un_un_8NHkco1q3l8ft"
    },
    {
      title: "3B - Mrs. Pinion",
      url: "https://www.amazon.com/hz/wishlist/ls/R1DSX55GIG45?ref_=wl_share"
    },
    {
      title: "4A - Mrs. White",
      url: "https://www.amazon.com/hz/wishlist/ls/10KAUCC0HMKCL?ref_=wl_share"
    },
    {
      title: "4B - Mrs. Woodburn",
      url: "https://www.amazon.com/hz/wishlist/ls/2C9XTPOSOHOZ8?ref_=wl_share"
    },
    {
      title: "5A - Mrs. Stafford (5/6 Reading and English)",
      url: "https://www.amazon.com/hz/wishlist/ls/17T2OWDELL5D6?ref_=wl_share"
    },
    {
      title: "5B - Mrs. Miller (5/6 Math/Interventions/Typing)",
      url: "https://www.amazon.com/hz/wishlist/ls/1UR0KDMIJ2T2D?ref=cm_sw_em_r_un_un_cfPxeYBy9zueX"
    },
    {
      title: "6A - Mrs. Umbach (5/6 Science/Stem)",
      url: "https://www.amazon.com/hz/wishlist/ls/3MWIEOTNAV7EL?ref_=wl_share"
    },
    {
      title: "6B - Mrs. Gibbs (5/6 History/Handwriting/Spelling)",
      url: "https://www.amazon.com/hz/wishlist/ls/ZGVSK3KNYTU4?ref=cm_sw_em_r_un_un_Fh487nPa7kktR"
    },
    {
      title: "7A - Mrs. McDaniel (Upper School Math)",
      url: "https://www.amazon.com/hz/wishlist/ls/1EP4RJD1S6A32?ref_=wl_share"
    },
    {
      title: "8 - Mrs. Courtney (History)",
      url: "https://www.amazon.com/hz/wishlist/ls/KSABOGWJKDUC?ref_=wl_share"
    },
  ];

  return (
    <Container>
      <SingleColumn>
        <HeadingInfoContainer>
          <HeadingTitle>Teacher Wish Lists</HeadingTitle>
          <HeadingDescription>
          CCS PTO is making it easier for parents to directly support their children's classrooms and school. Easily purchase the exact items the teachers want, and Amazon ships and keeps track of it all to avoid duplicate purchases. 
          Please note: If your student's teacher link is not working, this means we have not received a list. Please check back in the future as we are continually receiving Teacher Wish Lists.
          </HeadingDescription>
        </HeadingInfoContainer>

        <Content>
          {cards.map((card, i) => (
            <Card>
              <Details>
                <Link target="_blank" href={card.url}>{card.title}</Link>
              </Details>
            </Card>
          ))}
        </Content>
      </SingleColumn>
    </Container>
  );
};
